module.exports = __webpack_public_path__ + "static/media/Registration_Oauth.07e7dd36.gif";